import React from "react";
import FooterMenusData from "../Data/FooterMenu.js";
import { useTranslation } from "react-i18next";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
const FooterMenus = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const FooterMenusdata = FooterMenusData();
  return (
    <>
      {FooterMenusdata.map((item, index) => (
        <Col key={index}>
          <ul
            className={`d-flex flex-column gap-2 footer-ul ${
              lang === "en"
                ? "align-items-center align-items-sm-baseline align-items-md-baseline align-items-lg-baseline align-items-xxl-baseline"
                : "align-items-center"
            }`}
          >
            <h4 className="mb-0">{item.title}</h4>
            <span className="dashed-footer-border pb-4"></span>
            {/* <p>{item.text}</p> */}
            {item?.lists?.map((list, index) => (
              <Link
                className="text-light"
                key={index}
                to={list?.link?.toLowerCase()}
              >
                <li>
                  {list?.icon}
                  {list?.text}
                </li>
              </Link>
            ))}
          </ul>
        </Col>
      ))}
    </>
  );
};

export default FooterMenus;
